import AuthStore from 'stores/AuthStore';

export const oauthRedirect = (url: string) => {
  const {user} = AuthStore.getState();
  if (user.i360Embed) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};
